// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__v_Bro","item":"Breadcrumbs_item__mFBY_","link":"Breadcrumbs_link__xjp68"};